import { formatPhoneNumber } from '@frontend/phone-numbers';
import { LocationPhone } from '../types';

type LocationPhoneDisplayNameOptions = {
  onlyNameOrNumber?: boolean;
};

export const getLocationPhoneDisplayName = <T extends Pick<LocationPhone, 'displayName' | 'locationPhone'>>(
  { displayName, locationPhone }: T,
  options: LocationPhoneDisplayNameOptions = {}
): string => {
  if (displayName) {
    return options.onlyNameOrNumber ?? true
      ? displayName
      : `${displayName} ${formatPhoneNumber(locationPhone, true)}`.trim();
  } else {
    return formatPhoneNumber(locationPhone, true);
  }
};
